import React from "react";
import { Container } from "reactstrap";
import List from "./List";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import { PLATFORM_NAME } from "../../CommonData/Data/constant";

const Customer = ({ t }) => {
  document.title = t("document.title.customer", { PLATFORM_NAME });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            navigation={true}
            title={t("customer.breadcrumbs.list.title")}
            breadcrumbItem={t("customer.breadcrumbs.list.breadcrumbItem")}
          />
          <List />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Customer);

